export const apiUrl = process.env.REACT_APP_API_URL

export default {
	projectName: 'Nahartime',
	delayCheckTodayReport: 60000, // 60 sec
};

export const pageSEO = {
	home: {
		title: 'سفارش آنلاین غذای شرکتی | ناهارتایم',
		description:
			'سفارش آنلاین غذای شرکتی، تنوع در انتخاب، سادگی فرآیند سفارش، پرداخت هزینه غذا با امکان کسر از حقوق، اتصال به سیستم های حقوق و دستمزد و منابع انسانی.',
		keywords: 'سفارش آنلاین غذای شرکتی, ناهارتایم',
	},
	login: {
		title: 'ورود به سفارش آنلاین ناهارتایم',
	},
};
